import { MdOutlineEmojiPeople } from "react-icons/md";
import { useMediaQuery, useTheme } from "@mui/material";
import ShareOnSocial from "react-share-on-social";

import StyledButton from "../components/StyledButton";

const SocialShare = ({
  buttonText,
  textToShare,
  path,
  linkTitle,
  linkMetaDesc,
  style,
  icon = true,
  children = <></>,
}) => {
  let href = window.location.origin + "/" + path;
  let url = new URL(href);
  let urlToShare = url.search ? url + "&referer=social-share" : url + "?referer=social-share";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <ShareOnSocial
      textToShare={textToShare}
      link={urlToShare}
      linkTitle={linkTitle}
      linkMetaDesc={linkMetaDesc}
      linkFavicon="/logo192.png"
      closeText="Stäng"
      copyToClipboardText="Kopiera länken till testet"
      copySuccessText="Länk kopierad"
      openInWindow={true}
      noReferer
    >
      <StyledButton
        palette="primary"
        variant="secondary"
        style={{
          ...style,
        }}
        label={buttonText}
        icon={
          isMobile || icon === false ? undefined : <MdOutlineEmojiPeople style={{ fontSize: 20 }} />
        }
      >
        {children}
      </StyledButton>
    </ShareOnSocial>
  );
};

export default SocialShare;
